
export default {
  'limit': 12
};


// WEBPACK FOOTER //
// ./modules/browse/constants/DefaultFilters.js